<template>
  <div class="account-page">
    <h2>Please choose one of your accounts below.</h2>
    <p>
      It looks like you have multiple accounts. You can only manage one account
      at a time. Please select an account to manage.
    </p>
    <div class="accounts">
      <div
        v-for="acc in manager_accounts"
        :key="acc.index"
        @click="choose_account(acc.index)"
        class="account"
      >
        <p>{{ acc.name }}</p>
        <p class="arr">></p>
      </div>
    </div>
  </div>
</template>

<script>
import Register from "@/components/Register";
import firebase from "firebase";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;

export default {
  name: "accounts",
  components: {
    register: Register,
  },
  data() {
    return {};
  },
  computed: {
    manager_accounts() {
      let choices = [];
      let primary = this.$store.state.accounts.primary;
      if (primary) {
        choices.push({
          index: -1,
          name: primary.company + " - " + primary.name,
        });
      }
      choices = choices.concat(
        this.$store.state.accounts.managers.map((val, index) => {
          return {
            index,
            name: val.user_doc.company + " - " + val.user_doc.name,
          };
        })
      );
      return choices;
    },
  },
  methods: {
    choose_account(index) {
      return this.$store.dispatch("setManager", index).then(() => {
        this.$router.push({ path: "/dashboard" });
      });
    },
  },
  created() {},
};
</script>

<style lang="scss">
.account-page {
  padding: 30px;
  padding-top: 100px;
  max-width: 600px;
  margin: auto;
}

.accounts {
  display: flex;
  flex-direction: column;
  margin-top: 50px;
  .account {
    width: 100%;
    padding: 10px 20px;
    border: 1px solid #eaeaea;
    background: white;
    cursor: pointer;
    margin: 5px 0;
    display: flex;
    align-items: center;
    transition: transform 0.3s;
    position: relative;
    &:hover {
      transform: translateX(10px);
    }
    p {
      margin: 0;
    }
    .arr {
      position: absolute;
      right: 20px;
      opacity: 0.4;
      font-size: 20px;
    }
  }
}
</style>
